var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgProfileInRealWhiteCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    fill: "#FFFFFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20.25,
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 0.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4617 16.2472C16.4617 18.3563 18.2734 20.0726 20.4996 20.0726C22.7258 20.0726 24.5375 18.3563 24.5375 16.2472C24.5375 14.1382 22.7258 12.4219 20.4996 12.4219C18.2734 12.4219 16.4617 14.1382 16.4617 16.2472ZM27.678 28.5734H28.5753V27.7233C28.5753 24.4429 25.7569 21.7728 22.2942 21.7728H18.705C15.2414 21.7728 12.4238 24.4429 12.4238 27.7233V28.5734H27.678Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgProfileInRealWhiteCircle);
export default __webpack_public_path__ + "static/media/svgProfileInRealWhiteCircle.71a67de4676e774658bc18348ae6f99c.svg";
export { ForwardRef as ReactComponent };